import React from 'react';
import PropTypes from 'prop-types';

import { StyledFieldRow } from './styled';

const FieldRow = props => {
  const { marginTop, marginSides, children } = props;

  return (
    <StyledFieldRow marginTop={marginTop} marginSides={marginSides} {...props}>
      {children}
    </StyledFieldRow>
  );
};

FieldRow.propTypes = {
  marginTop: PropTypes.string,
  marginSides: PropTypes.string,
};

export { FieldRow };
